import { useEffect, useState } from "react";
import { ActionModule } from "../../types/actionModule/actionModule";
import { useAppDispatch } from "../StoreHooks";
import { actionModulesApi } from "../../api/actionsModulesApi";
import { setProcessingRequest } from "../../store/reducers/tableManagementReducer";
import { handleRequest } from "../../store/utils/handleRequest";
import { useTranslation } from "react-i18next";

export default function useActionModule(
    actionModuleId: string | undefined,
    companyId: number | undefined = undefined
): { isLoading: boolean, actionModule?: ActionModule, isError: boolean, } {
    const { t } = useTranslation();

    const dispatch = useAppDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [actionModule, setActionModule] = useState<ActionModule | undefined>();

    useEffect(() => {
        const fetchActionModule = async () => {
            if (!actionModuleId) return;
            setIsLoading(true);
            dispatch(setProcessingRequest(true));

            const result = await handleRequest(
                dispatch,
                "indirect",
                async () => companyId
                    ? await actionModulesApi.adminGetAction(actionModuleId, companyId)
                    : await actionModulesApi.getAction(actionModuleId),
                "",
            );

            setIsLoading(false);
            dispatch(setProcessingRequest(false));
            setIsError(result.success());

            setActionModule(result?.result ?? undefined);
        };
        fetchActionModule();
    }, [actionModuleId]);

    return {
        isLoading: isLoading,
        actionModule: actionModule,
        isError: isError,
    }
}